import { fromCents, toCents } from './money.js';
export const DEFAULT_LICENCE_THRESHOLDS = { green: 0, yellow: 10 };
export function licenceLight(listPrice, sold, premium, thresholds) {
    const list = toCents(listPrice);
    const soldCents = toCents(sold);
    const room = list - Math.min(toCents(premium), list);
    const off = list - soldCents;
    const discount = room > 0 ? Math.ceil((off * 1000) / room) / 10 : 0;
    // On the exact discount: off ÷ room ≤ threshold ÷ 100.
    const within = (threshold) => room <= 0 || off * 100 <= threshold * room;
    const light = within(thresholds.green)
        ? 'green'
        : within(thresholds.yellow)
            ? 'yellow'
            : 'red';
    return {
        listPrice: fromCents(list),
        sold: fromCents(soldCents),
        discount,
        light,
        yellowFloor: fromCents(list - Math.floor((room * thresholds.yellow) / 100)),
    };
}
/** Le soglie dalla tabella Soglie licenze: voci VERDE e GIALLO, colonna «percent». */
export function licenceThresholdsFrom(entries) {
    const value = (code, fallback) => {
        const raw = entries.find((entry) => entry.code === code)?.values.percent;
        const found = Number(raw);
        return raw !== null && raw !== undefined && Number.isFinite(found) && found >= 0
            ? found
            : fallback;
    };
    return {
        green: value('VERDE', DEFAULT_LICENCE_THRESHOLDS.green),
        yellow: value('GIALLO', DEFAULT_LICENCE_THRESHOLDS.yellow),
    };
}
//# sourceMappingURL=licence-lights.js.map